import React from 'react';
/**
 * Augment forwardRef to enable usage with generic components
 * see: https://fettblog.eu/typescript-react-generic-forward-refs/#option-3%3A-augment-forwardref
 */

export function genericForwardRef(render) {
  return /*#__PURE__*/React.forwardRef(render);
}